<template>
  <div class="dashbord_cla">
    <div v-if="companyNum>0" class="grid-content to-data" @click="toCompany">
      <charItem>
        <i class="zk-icon-qiyexinxi icon_cla" slot="icon"></i>
        <template slot="number">
          <span class="tip_cla">{{ $t('developer.companyNum') }}：</span>
          <span class="num_cla">{{ companyNum }}</span>
        </template>
      </charItem>
    </div>

    <div class="grid-content to-data" @click="toDevice">
      <charItem>
        <i class="shebeiliebiao-cla" slot="icon"></i>
        <template slot="number">
          <span class="tip_cla">{{ $t('developer.deviceTotle') }}：</span>
          <span class="num_cla">{{ total }}</span>
        </template>
      </charItem>
    </div>

    <div class="grid-content">
      <charItem>
        <i class="zk-icon-wifi icon_cla" slot="icon"></i>
        <template slot="number">
          <span class="tip_cla">{{ $t('developer.onLineCount') }}：</span>
          <span class="num_cla">{{ online }}</span>
        </template>
      </charItem>
    </div>

    <div class="grid-content">
      <charItem>
        <i class="zk-icon-lixian1 icon_cla" slot="icon"></i>
        <template slot="number">
          <span class="tip_cla">{{ $t('developer.offlineCount') }}：</span>
          <span class="num_cla">{{ offline }}</span>
        </template>
      </charItem>
    </div>

    <div class="grid-content">
      <charItem>
        <i class="iconfont zk-icon-jinyong_2 icon_cla" slot="icon"></i>
        <template slot="number">
          <span class="tip_cla">{{ $t('dashboard.disableDevice') }}：</span>
          <span class="num_cla">{{ disableNum }}</span>
        </template>
      </charItem>
    </div>

    <div class="grid-content to-data" @click="toDataTransferStation">
      <charItem>
        <i class="TransferStation-icon-cla" slot="icon"></i>
        <template slot="number">
          <span class="tip_cla">{{ $t('developer.relayNum') }}：</span>
          <span class="num_cla">{{ relayNum }}</span>
        </template>
      </charItem>
    </div>
  </div>
</template>

<script>
import charItem from './charItem'
import { pageIndex } from '@/services/appManagerApi.js'
// import { mapActions } from 'vuex'
export default {
  data() {
    return {
      relayNum: 0,
      offline: 0,
      total: 0,
      online: 0,
      disableNum: 0,
      companyNum: 0,
      employeeNum: 0
    }
  },
  components: {
    charItem
  },
  mounted() {
    this.getDashboard()
  },
  props: {
    appInfo: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  watch: {
    'appInfo.appKey': {
      handler: function(val, oVal) {
        if (val) {
          this.getDashboard()
        }
      },
      deep: true
    }
  },
  methods: {
    toEmploye() {
      this.$router.push('/enterpriseAdmin/employee')
      this.$root.appKey = this.appInfo.appKey
    },
    toCompany() {
      this.$root.appKey = this.appInfo.appKey
      this.$router.push({
        path: '/tenantManager',
        query: { appId: this.appInfo.appKey }
      })
    },
    toDevice() {
      this.$root.appKey = this.appInfo.appKey

      this.$router.push({
        path: '/deviceManager/deviceList',
        query: {
          appId: this.appInfo.appKey
        }
      })
    },
    toDataTransferStation() {
      this.$emit('toDataTransferStation')
    },
    getDashboard() {
      if (!this.appInfo.appKey) {
        return false
      }
      let parms = {
        appKey: this.appInfo.appKey
      }
      pageIndex(parms)
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.results
            this.relayNum = result.relayNum
            this.offline = result.offline
            this.total = result.total
            this.online = result.online
            this.disableNum = result.disableNum
            this.companyNum = result.companyNum
          }
        })
        .catch(data => {})
    }
  }
}
</script>

<style scoped lang="less">
.to-data:hover {
  cursor: pointer;
}

.icon-base-cla {
  width: 80px;
  height: 80px;
  background-size: 35px 35px;
  background-repeat: no-repeat;
  background-position-x: 20px;
  background-position-y: 20px;
  background-color: #ecfbe8;
}

.shebeiliebiao-cla {
  .icon-base-cla;
  background-image: url('~~@/assets/new/image/device.svg');
}

.TransferStation-icon-cla {
  .icon-base-cla;
  background-image: url('~~@/assets/new/image/transferStation.svg');
}

.dashbord_cla {
  display: flex;
  flex-wrap: wrap;
  .grid-content {
    width: 338px;
    height: 80px;
    margin-bottom: 12px;
  }
  .grid-content:nth-child(3n-1) {
    padding-right: 4px;
    padding-left: 4px;
  }
  .grid-content:nth-child(3n + 1) {
    padding-right: 8px;
  }
  .grid-content:nth-child(3n) {
    padding-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting/dashboard.vue